import { ApiAIPrompt, ApiProject } from "@incendium/api";
import { listPromptBilling } from "features/ai/services/aiService";
import { useProjectSharedState } from "Hooks/useSharedState";

const fetchPromptBillings = async (project: ApiProject): Promise<ApiAIPrompt[]> => {
  const prompts = await listPromptBilling(project.id as number);
  return prompts ?? [];
};

const useAIPromptBillings = () => {
  const { state, setState, loading, refetch } = useProjectSharedState<ApiAIPrompt[]>(
    "aiPromptBillings",
    [],
    fetchPromptBillings
  );

  return {
    prompts: state,
    setPrompts: setState,
    loading,
    refetch,
  };
};

export default useAIPromptBillings;
